import { render, staticRenderFns } from "./languageManagement.vue?vue&type=template&id=6051ee04&scoped=true&"
import script from "./languageManagement.vue?vue&type=script&lang=js&"
export * from "./languageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051ee04",
  null
  
)

export default component.exports